import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Es difícil de hacer?',
  a: 'No. Si puedes pelar una mandarina y armar un sándwich, puedes usar este Kit. Está diseñado para mamás reales, no para chefs profesionales.'
}, {
  q: '¿Necesito ingredientes raros?',
  a: 'No. Todo se encuentra en cualquier supermercado local de Latinoamérica. Usamos ingredientes comunes, económicos y accesibles.'
}, {
  q: '¿Es seguro el pago?',
  a: 'Sí, utilizamos una plataforma de pago internacional con encriptación de seguridad bancaria. Tus datos están 100% protegidos.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'Es 100% digital. Recibes un enlace de descarga en tu email 1 segundo después de la compra. Puedes leerlo en tu celular, tablet o imprimirlo.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-10 px-4 bg-sage-50" data-id="element-41">
      <div className="max-w-3xl mx-auto" data-id="element-42">
        <div className="text-center mb-12" data-id="element-43">
          <h2 className="text-3xl font-black text-charcoal-900 mb-4" data-id="element-44">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-45">
          {faqs.map((faq, idx) => <div key={idx} className="bg-white rounded-2xl shadow-sm border border-cream-200 overflow-hidden" data-id="element-46">
              <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-47">
                <span className="font-bold text-charcoal-900 text-lg" data-id="element-48">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-azul-polvo-500 transition-transform duration-300 ${openIndex === idx ? 'rotate-180' : ''}`} data-id="element-49" />
              </button>

              <AnimatePresence data-id="element-50">
                {openIndex === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-51">
                    <div className="px-6 pb-5 text-charcoal-700 border-t border-cream-100 pt-3" data-id="element-52">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}